import React, { useState } from 'react'
import Loader from 'components/Loader'
import './index.css'
import useDispatch from 'hooks/use-dispatch'
import toggleProductVariantRatingStatusAction from 'modules/product/redux/actions/toggle-product-variant-rating-status'
import logEventAnalyticsUtil from 'utils/analytics/log-event'

const ANALYTICS_EVENT = {
  SHOW_RATE_PRODUCT_CARD: 'SHOW_RATE_PRODUCT_CARD',
  RATE_LIKE_FROM_PRODUCT_CARD: 'RATE_LIKE_FROM_PRODUCT_CARD',
  RATE_DISLIKE_FROM_PRODUCT_CARD: 'RATE_DISLIKE_FROM_PRODUCT_CARD'
}

/**
 * @param onClickLikeSample
 * @returns {JSX.Element}
 * @constructor
 */
const ProductCardLikeAndDislikeButtons = ({
  variantId,
  productId,
  openAddFullSizeModal
}) => {
  const dispatch = useDispatch()

  const [loadingLike, setLoadingLike] = useState(false)
  const [loadingDislike, setLoadingDislike] = useState(false)

  const handleMount = () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_RATE_PRODUCT_CARD, {
      variantId,
      productId
    })
  }

  React.useEffect(() => {
    handleMount()
  }, [])

  const onClickLikeSample = async () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.RATE_LIKE_FROM_PRODUCT_CARD, {
      variantId
    })

    setLoadingLike(true)

    await dispatch(
      toggleProductVariantRatingStatusAction({
        variantId,
        productId,
        rating: 'like'
      })
    )

    openAddFullSizeModal()
    setLoadingLike(false)
  }

  const onDislikeSample = async () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.RATE_DISLIKE_FROM_PRODUCT_CARD, {
      variantId
    })

    setLoadingDislike(true)

    await dispatch(
      toggleProductVariantRatingStatusAction({
        variantId,
        productId,
        rating: 'not_like'
      })
    )
    setLoadingDislike(false)
  }

  return (
    <div className='product-card-like-and-dislike-buttons'>

      <button
        disabled={loadingDislike}
        onClick={onDislikeSample}
        className='product-card-dislike-button'
      >
        {
          loadingDislike
            ? (
              <div className='loader-wrapper'>
                <Loader />
              </div>
              )
            : (
              <svg
                width='25'
                height='24'
                viewBox='0 0 25 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M19.405 17.47C19.698 17.763 19.698 18.238 19.405 18.531C19.259 18.677 19.067 18.751 18.875 18.751C18.683 18.751 18.491 18.678 18.345 18.531L12.875 13.061L7.40499 18.531C7.25899 18.677 7.06699 18.751 6.87499 18.751C6.68299 18.751 6.49099 18.678 6.34499 18.531C6.05199 18.238 6.05199 17.763 6.34499 17.47L11.815 12L6.34499 6.53005C6.05199 6.23705 6.05199 5.76202 6.34499 5.46902C6.63799 5.17602 7.113 5.17602 7.406 5.46902L12.876 10.939L18.346 5.46902C18.639 5.17602 19.114 5.17602 19.407 5.46902C19.7 5.76202 19.7 6.23705 19.407 6.53005L13.937 12L19.405 17.47Z'
                  fill='#191531'
                />
              </svg>
              )
        }
      </button>
      <button
        disabled={loadingLike}
        onClick={onClickLikeSample}
        className='product-card-like-button'
      >
        {
          loadingLike
            ? (
              <div className='loader-wrapper'>
                <Loader />
              </div>
              )
            : (
              <svg
                width='17'
                height='14'
                viewBox='0 0 17 14'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M4.61952 0.253129C4.12771 0.253129 3.60512 0.353445 3.05869 0.58362C0.671158 1.5887 0.0665254 4.11892 0.515097 6.04469C1.61512 10.7695 7.6218 13.4677 8.37828 13.7901C9.13476 13.4672 15.1417 10.7661 16.2413 6.04469C16.6898 4.11892 16.0852 1.58848 13.6974 0.583408C11.3704 -0.396376 9.47366 0.974471 8.5567 2.44585C8.47993 2.56975 8.27705 2.56975 8.19965 2.44585C7.4978 1.32005 6.22231 0.253129 4.61952 0.253129Z'
                  fill='#E15EC4'
                />
              </svg>
              )
        }
      </button>
    </div>
  )
}

export default ProductCardLikeAndDislikeButtons
